<template>
  <div>
    <b-modal v-model="modalShow" centered hide-header hide-footer ok-disabled cancel-disabled>
      <div class="d-block text-center modal-container">
        <div class="subject">
          <div class="subject-text">
            <div class="subject-text">{{ shopName }}</div>
            <div class="subject-text">{{ seatNo }}番席</div>
          </div>
        </div>
        <div class="desc">
          くら寿司アプリから、このQRコードを読み込むと注文ができるようになります。
        </div>
        <div class="qrimage">
          <b-img :src="childrenQr" />
        </div>
        <div class="footer">
          <so-close-button @click="handleCancel">{{ $t('common.close') }}</so-close-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  name: 'QRForChildrenModal',
  components: {
    SoCloseButton,
  },
  computed: {
    ...mapGetters({
      shopName: 'seat/getShopName',
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
      childrenQr: 'setting/getChildrenQr',
      languageId: 'setting/getLanguage',
      isShowingModal: 'modal/isShowingQRForChildrenModal',
    }),
    modalShow: {
      get() {
        return this.isShowingModal
      },
      set(value) {
        this.$store.dispatch('modal/setShowingQRForChildrenModal', value)
      },
    },
  },
  watch: {
    languageId(newLanguage) {
      this.$i18n.locale = newLanguage
    },
  },
  methods: {
    handleCancel() {
      this.$store.dispatch('modal/setShowingQRForChildrenModal', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.subject {
  color: #d21b24;
  padding: 10px;
  &-icon {
    margin: 10px 0 30px;
  }
  &-text {
    font-size: 18px;
    font-weight: bold;
  }
}
.desc {
  color: #222222;
  font-size: 14px;
  margin: 10px 0;
}
.qrimage {
  margin: 30px 10%;
  @media (max-width: 576px) {
    margin: 30px 0 10px;
  }
}
.footer {
  margin-top: 20px;
}
</style>
